import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { ExtractParams } from '@/types/params';

import DashboardHeader from '@/@mui/dashboard/DashboardHeader';
import { useGetDocument } from '@/api/endpoints/document/useGetDocument';
import { PMPRoutes } from '@/config/routes';
import { useAuth } from '@/context/AuthProvider';

import DocumentUploadV2Stream from '@/components/document/DocumentUploadV2Stream';
import DocumentViewer from '@/components/document/DocumentViewer';

const DocumentViewPage: React.FC = () => {
  const { id } = useParams<ExtractParams<PMPRoutes.documentView>>();
  const { session } = useAuth();
  const history = useHistory();

  const fetchDocumentQuery = useGetDocument(id, session);

  const breadcrumbs = useMemo(
    () =>
      history.length > 1 ? [{ label: 'Go Back', onClick: () => history.goBack() }] : undefined,
    [history]
  );

  const handleUploadComplete = () => {
    // Refetch document data after processing
    fetchDocumentQuery.refetch();
  };

  return (
    <Stack direction="column" spacing={2} sx={{ flex: '1 1 100%' }}>
      <DashboardHeader title={fetchDocumentQuery.data?.original_name} breadcrumbs={breadcrumbs} />

      {/* V2 Streaming Upload Component */}
      <DocumentUploadV2Stream
        documentId={id}
        documentData={{
          original_name: fetchDocumentQuery.data?.original_name,
          created_by: fetchDocumentQuery.data?.created_by,
          status: fetchDocumentQuery.data?.status,
        }}
        onUploadComplete={handleUploadComplete}
      />

      <DocumentViewer id={id} session={session} layoutType="page" />
    </Stack>
  );
};

export default DocumentViewPage;
